/**
 * Test IDs for MateList component elements
 * This library provides a centralized way to generate test IDs for mate list elements
 * to ensure consistency between the component and tests.
 */
export const mateListTestIds = {
  /**
   * Test ID for the mate list sidebar element
   */
  sidebar: 'mate-list-sidebar',

  /**
   * Test ID for the auto switch checkbox (in Omni mode)
   */
  autoSwitchCheckbox: 'mate-list-auto-switch-checkbox',

  /**
   * Test ID prefix for player boxes (will be appended with player ID, e.g., 'mate-list-player-0')
   */
  playerBox: 'mate-list-player',

  /**
   * Test ID for the "Playing as" indicator (in Omni mode)
   */
  playingAsIndicator: 'mate-list-playing-as',

  /**
   * Test ID for the "Add Bot" button
   */
  addAIPlayerButton: 'mate-list-add-ai-player-button',

  /**
   * Test ID for the Omni mode info button (opens an explainer dialog)
   */
  omniModeInfoButton: 'mate-list-omni-mode-info-button',

  /**
   * Test ID for the Omni mode info dialog's content
   */
  omniModeInfoDialog: 'mate-list-omni-mode-info-dialog',

  /**
   * Test ID for the read-only "Omni Mode" label shown to clients who cannot control it
   */
  omniModeReadOnlyLabel: 'mate-list-omni-mode-readonly-label',

  /**
   * Test ID for the Omni mode player-count dropdown
   */
  omniPlayerCountSelect: 'mate-list-omni-player-count-select',
} as const
